import { render } from "./RecoveryPasswordChangePage.vue?vue&type=template&id=58a9d327"
import script from "./RecoveryPasswordChangePage.vue?vue&type=script&lang=js"
export * from "./RecoveryPasswordChangePage.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/customer-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__